const new_arrivals = [
    { id: 1, name: "Wooden Beech Chair"},
    { id: 2, name: "Arafat Coffee"},
    { id: 3, name: "Winter Fabrics"},
    { id: 4, name: "Herbals"},
];

export default new_arrivals;
